import React from 'react';
import {Stack, Typography} from '@mui/material';
import {BrandBox, HeaderContainer, SubtitleText, TitleText, TopRow,} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import {LogoutMenu} from "../../LogoutMenu";

export default function Header() {
    const {settings: {firm, landing}, businessName, avatar} = useDashboardContext();
    return (
        <HeaderContainer>
            <TopRow>
                <BrandBox>
                    <Stack sx={{gap: 0.5}}>
                        <TitleText>{firm.name}</TitleText>
                        <SubtitleText>{landing.description}</SubtitleText>
                    </Stack>
                </BrandBox>
            </TopRow>
            <Typography variant="body2" component="div" style={{fontWeight: 600, color: '#333', marginTop: 8}}>
                <LogoutMenu>
                    <Stack direction={"row"} sx={{alignItems: "center", gap: 1}}>
                        ✨
                        <img style={{width: 25, borderRadius: "50%"}} src={avatar} alt={businessName}/>
                        {businessName}
                    </Stack>
                </LogoutMenu>
            </Typography>
        </HeaderContainer>
    );
}
